import { isEmpty } from 'ramda';

import { IAddressSuggest, IMultiSuggestResult, IResultSuggestions } from '@cian/geosuggest-widget';
import { IHttpApi } from '@cian/http-api/shared';

import { loadYmapsApi } from '../../services/ymaps';
import { sendTelemetryCounter, sendTelemetryTimer } from '../../services/telemetry';
import { MCS_NAME } from '../../constants/mcsName';
import { TThunkAction } from '../../types/redux';

export interface IYandexSuggestParams {
  request: string;
}

const prepareTelemetryTimerTracker = (mcsName: string, httpApi: IHttpApi) => {
  const startTimeRequest = new Date().getTime();

  return () => {
    const endTimeRequest = new Date().getTime() - startTimeRequest;

    sendTelemetryTimer({
      httpApi,
      key: `${mcsName}.yandex-suggest.timer`,
      value: endTimeRequest,
    });
  };
};

export const getYandexSuggest = (params: IYandexSuggestParams): TThunkAction<Promise<IMultiSuggestResult>> => {
  return async (dispatch, getState, context) => {
    const { httpApi, logger } = context;

    const defaultData = {
      sortOrder: [],
      suggestions: {
        addresses: [],
      },
    };

    let yaSuggestResult: YMaps.ISuggestResult[] | YMaps.IScriptError | null = null;
    const suggestions: IResultSuggestions = {};

    const yandexSuggestApi = await loadYmapsApi({ require: ['suggest'] });

    const trackTelemetryTimer = prepareTelemetryTimerTracker(MCS_NAME, httpApi);

    try {
      yaSuggestResult = await yandexSuggestApi.suggest(`Россия, ${params.request}`);

      sendTelemetryCounter({
        httpApi,
        key: `${MCS_NAME}.yandex-suggest.200`,
      });

      trackTelemetryTimer();
    } catch (e) {
      logger.warning('Invalid yandex suggest api request', e);

      return defaultData;
    }

    /** Ошибку можно поймать, отрубив интернет */
    if ('message' in yaSuggestResult) {
      logger.warning('Yandex suggest script error');

      return defaultData;
    }

    if (!isEmpty(yaSuggestResult)) {
      suggestions.addresses = yaSuggestResult as IAddressSuggest[];
    }

    return {
      suggestions,
      sortOrder: ['addresses'],
    };
  };
};
